import { render } from "./uploader.vue?vue&type=template&id=b6d44578&scoped=true"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"

import "./uploader.vue?vue&type=style&index=0&id=b6d44578&lang=scss&scoped=true"
import "./uploader.vue?vue&type=style&index=1&id=b6d44578&lang=scss"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d44578"]])

export default __exports__